import script from "./VendorSchedulePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorSchedulePage.vue?vue&type=script&setup=true&lang=ts"

import "./VendorSchedulePage.vue?vue&type=style&index=0&id=927e1168&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-927e1168"]])

export default __exports__